var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('one-cms-grid-render',{class:_vm.mainComponentClass,attrs:{"element":_vm.content,"available-components":_vm.availableComponents}})
}
var staticRenderFns = []

export { render, staticRenderFns }